module.exports = __webpack_public_path__ + "static/media/IMG_20161202_211438.92362778.jpg";